export default {
  first_name: 'first name',
  last_name: 'last name',
  password_confirmation: 'password confirmation'
}
